import axios from "axios";
import { getStoredToken } from "../utils/authUtils";

/**
 * Get auth token from storage or fallback (dev only)
 */
function getAuthToken(): string | null {
  const storedToken = getStoredToken();

  if (storedToken) {
    return storedToken.startsWith("Bearer ")
      ? storedToken
      : `Bearer ${storedToken}`;
  }

  console.warn(
    "No auth token found in localStorage, using fallback token for development"
  );

  return "";
}

/**
 * Axios instance
 */
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Request interceptor → attach token automatically
 */
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    if (token) {
      config.headers.Authorization = token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Optional: response interceptor (good place for 401 handling later)
 */
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Example:
    // if (error.response?.status === 401) {
    //   logoutUser();
    // }
    return Promise.reject(error);
  }
);

export default axiosInstance;
